export default class Model {
    constructor(values = {}) {
        this.fill({
            ...{ id: null },
            ...this.constructor.defaults,
            ...values,
        });
    }

    fill(values) {
        if (!values) {
            return;
        }

        for (const [field, value] of Object.entries(values)) {
            this[field] = value;
        }
    }

    isValid() {
        // eslint-disable-next-line no-console
        console.warn('You must overwrite the "isValid" method in the child entity.');
        return false;
    }

    isExisting() {
        return !!this.id;
    }
}
